// extracted by mini-css-extract-plugin
export default {"searchResult":"styles_searchResult__s9WgI","searchResult__item":"styles_searchResult__item__KawsX","wrapper":"styles_wrapper__Zr8a9"};